import { DocumentTemplateTypeEnum } from '../../../shared/models';

export interface DefaultDocumentTemplateConfig {
  key: string;
  label: string;
  description: string;
  type: DocumentTemplateTypeEnum;
  filePath: string;
  fileName: string;
  mimeType: string;
}

export const DEFAULT_DOCUMENT_TEMPLATES: DefaultDocumentTemplateConfig[] = [
  {
    key: 'power_of_attorney',
    label: 'Power of Attorney',
    description: 'Default Power of Attorney template for electronic signature',
    type: DocumentTemplateTypeEnum.electronic_signature,
    filePath: 'document-templates/power_of_attorney_template.docx',
    fileName: 'power_of_attorney_template.docx',
    mimeType:
      'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
  },
];
